// @ts-check
/* global module */
'use_strict';

/**
 * Manages generation of FAQ schema.
 *
 * @property {Dictionary<string, HTMLElement>} elements we need to interact with.
 */
export class FAQSchema {
    elements: { [key: string]: HTMLElement } = {};

    /**
     * Instantiate the class, default values and bind to the elements.
     */
    constructor() {
        this.bind();
    }

    /**
     * Bind functions for the FAQ schema.
     *
     * @returns {void}
     */
    bind(): void {
        const faq_section = <HTMLElement> document.getElementById('faq-section');
        if (faq_section) {
            this.create_faq_schema(faq_section);
        }
    }

    /**
     * Considers the classes added to a category or product FAQ section
     * and applies appropriate schema attributes.
     * 
     * @param {HTMLElement} contains the FAQ section in a div
     * @returns {void}
     */
    create_faq_schema(faq_section): void {
        faq_section.setAttribute('itemscope', '');
        faq_section.setAttribute('itemtype', 'https://schema.org/FAQPage');

        const tv_question_containers = document.querySelectorAll('.tv-faq-question-container');
        const tv_answer_containers = document.querySelectorAll('.tv-faq-answer-container');

        for (const tv_question_container of tv_question_containers) {
            tv_question_container.setAttribute('itemscope', '');
            tv_question_container.setAttribute('itemprop', 'mainEntity');
            tv_question_container.setAttribute('itemtype', 'https://schema.org/Question')
            const question_text_elements = tv_question_container.querySelectorAll('p');

            for (const question_text_element of question_text_elements) {
                question_text_element.setAttribute('itemprop', 'name');
            }   
        }

        for (const tv_answer_container of tv_answer_containers) {
            tv_answer_container.setAttribute('itemscope', '');
            tv_answer_container.setAttribute('itemprop', 'acceptedAnswer');
            tv_answer_container.setAttribute('itemtype', 'https://schema.org/Answer')
            const question_text_elements = tv_answer_container.querySelectorAll('p');

            for (const question_text_element of question_text_elements) {
                question_text_element.setAttribute('itemprop', 'text');
            }   
        }
    }
}

export function init() {
    if (!document.getElementById('tv-faq-section') && document.getElementById('faq-section')) {
        (() => new FAQSchema())();
    }
}